import React from 'react';

import { Route } from 'react-router-dom';

import InternalServer from 'components/common/ErrorPages/InternalServer';
import { PageNotFound } from 'components/common/ErrorPages/pageNotFound';

import { ExternalLogin } from 'components/App/AuthPublicPages/ExternalLogin/externalLogin';
import { ExternalRedirect } from 'components/App/AuthPublicPages/ExternalRedirect/externalRedirect';
import { ForgotPassword } from 'components/App/AuthPublicPages/ForgotPassword/forgotPassword';
import Login from 'components/App/AuthPublicPages/Login/login';
import { Logout } from 'components/App/AuthPublicPages/Logout/logout';
import { Mfa } from 'components/App/AuthPublicPages/Mfa/mfa';
import { MfaSignUp } from 'components/App/AuthPublicPages/MfaSignUp/mfaSignUp';
import { ResetPassword } from 'components/App/AuthPublicPages/ResetPassword/resetPassword';

export const PublicRoutes = () => {
    const url = new URL(document.URL);
    const domain = url.hostname;
    return [
        <Route
            exact
            key={'login'}
            path={'/login'}
            render={() => {
                return domain === 'kc.works' ? <ExternalRedirect /> : <Login />;
            }}
        />,
        <Route exact key={'forgotpassword'} path={'/forgotpassword'} component={ForgotPassword} />,
        <Route exact key={'resetpassword'} path={'/resetpassword'} component={ResetPassword} />,
        <Route exact key={'mfa'} path={'/mfa'} component={Mfa} />,
        <Route exact key={'mfaSignUp'} path={'/mfaSignUp'} component={MfaSignUp} />,
        <Route key={'error500'} path={'/error500'} component={InternalServer} />,
        <Route key={'error404'} path={'/error404'} component={PageNotFound} />,
        <Route key={'logout'} path={'/logout'} component={Logout} />,
        <Route key={'externalLogin'} path={'/externalLogin'} component={ExternalLogin} />,
    ];
};
